module.exports = __webpack_public_path__ + "media/images/home/boxes/Group 4210-3a2706cc726a982871d811eab60ded19.svg";